var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.control.additionalFieldClass,domProps:{"textContent":_vm._s(_vm.localizedText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }